import React from 'react';
import PropTypes from 'prop-types';
import MiniLoader from './miniLoader';
const Ending = ({
  endingMessage: _endingMessage = null,
  isLoading: _isLoading = false
}) => {
  if (_endingMessage) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, _endingMessage);
  }
  return _isLoading ? /*#__PURE__*/React.createElement(MiniLoader, null) : null;
};
Ending.propTypes = {
  endingMessage: PropTypes.string,
  isLoading: PropTypes.bool
};
export default Ending;